import styled from "styled-components";
import tw from "twin.macro";

export const Wrapper = styled.div<{ disabled?: boolean }>`
	${tw`border border-dashed border-brand-strong-100 border-2 rounded-8 bg-brand-strong-20 flex items-center px-24 py-20 gap-16 cursor-pointer`}
	${(p) => (p.disabled ? tw`border-shade-60 bg-shade-10 cursor-not-allowed` : "")}
`;
export const HiddenInput = tw.input`hidden`;
